import * as tokenTypes from "../types/token";

const initState = {
  session: ''
};

export default (state = initState, action) => {
  switch (action.type) {
    case tokenTypes.SEND_TOKEN:
      return {
        ...state,
        session: action.data
      }
    case tokenTypes.CLEAN_TOKEN:
        return {
            ...state,
            session: ''
        }
    default:
      return state;
  }
};
